import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 — React-City</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center bg-surface-50 dark:bg-[#1b1b1f] px-4">
        <div className="text-center animate-in">
          <span className="text-6xl block mb-4">🌿</span>
          <h1 className="text-6xl font-bold text-heading mb-2">404</h1>
          <p className="text-xl text-muted mb-8">
            Questa pagina non esiste nel Movimento del Dono
          </p>
          <Link to="/" className="btn-primary btn-lg no-underline">
            Torna alla home
          </Link>
        </div>
      </div>
    </>
  );
}
